var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mkt"},[_c('Search'),_c('Tab',{ref:"tabRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }